<template>
  <div>
    <div
      class="newadd pr marginTop30 marginBom30 fsize32 fcolor_white flex-yCenter"
      @click="goAddDetail"
    >
      <span>提交申请</span>
      <img src="@/assets/images/index/addDetail.png" alt />
      <span class="fsize14 pa" style="left: 260px; top: 50px">点击进入</span>
    </div>
    <div class="myApply marginBom24">
      <div class="marginBom24 categoryTitle flex-yCenter">
        <div class="line"></div>
        我的申请
      </div>
      <div class="flex-sb">
        <div class="left flex-yCenter">
          <span class="fsize24">申请记录：</span>
          <span class="fsize40 fcolor_blue2 fweight600">
            {{ trainApplyList.length }}
          </span>
        </div>
        <div class="right flex-yCenter">
          <div class="flex-column pr" @click="$router.push({ path: '/record/index' })">
            <span class="fsize35 fcolor_gray fweight600">
              {{
                trainApplyList.filter(
                  (item) => item.applyStatus == 0 && item.revokeStatus == 0
                ).length
              }}
            </span>
            <span class="fsize20 fcolor_gray fweight600">审核中</span>
          </div>
          <div class="flex-column">
            <span class="fsize35 fcolor_skyBlue fweight600">
              {{
                trainApplyList.filter(
                  (item) => item.applyStatus == 1 && item.revokeStatus == 0
                ).length
              }}
            </span>
            <span class="fsize20 fcolor_skyBlue fweight600">已通过</span>
          </div>
          <div class="flex-column pr" @click="$router.push({ path: '/record/index' })">
            <span class="fsize35 fcolor_black fweight600">
              {{
                trainApplyList.filter(
                  (item) => item.applyStatus == 2 && item.revokeStatus == 0
                ).length
              }}
            </span>
            <span class="fsize20 fcolor_black fweight600">已驳回</span>
          </div>
          <div class="flex-column">
            <span class="fsize35 fcolor_gray fweight600">
              {{ trainApplyList.filter((item) => item.revokeStatus == 1).length }}
            </span>
            <span class="fsize20 fcolor_gray fweight600">已撤销</span>
          </div>
        </div>
      </div>
    </div>
    <div class="notice">
      <div class="marginBom30 categoryTitle flex-yCenter">
        <div class="line"></div>
        进修公告
      </div>
      <vue-seamless-scroll
        v-if="noticeList.length > 0"
        :data="noticeList"
        class="seamless-warp"
        :class-option="defaultOption"
      >
        <ul class="ul-scoll list">
          <li
            :class="{
              bgEven: (index + 1) % 2 == 0,
              bgFalse: (index + 1) % 2 != 0,
              item: true,
              'flex-sb': true,
              pointer: true,
            }"
            v-for="(item, index) in noticeList"
            :key="index"
            @click="$router.push({ path: '/previewNotice', query: item })"
          >
            <div class="flex-center">
              <div>
                <span>{{ item.announcementTitle }}</span>
              </div>
            </div>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
    <el-dialog title="驳回原因" :visible.sync="dialogVisible" width="30%">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { trainApplySelectApplyList, trainAnnouncementList } from "@/utils/api";
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      trainApplyList: [],
      noticeList: [],
      dialogVisible: false,
    };
  },
  created() {
    this.getData();
  },
  computed: {
    defaultOption() {
      return {
        step: 0.6, // 数值越大速度滚动越快
        limitMoveNum: 7, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  methods: {
    getData() {
      let obj = {
        params: {
          // beginApplyTime:'2023-01-01',
          // endApplyTime:'2023-01-11',
        },
        // trainType:'2'
      };
      trainApplySelectApplyList(obj).then((res) => {
        if (res.code == 200) {
          this.trainApplyList = res.data;
        }
      });
      trainAnnouncementList({
        publishStatus: 1,
        announcementRoleType: JSON.parse(localStorage.getItem("userInfo")).userType,
      }).then((res) => {
        if (res.code == 200) {
          this.noticeList = res.rows;
        }
      });
    },
    goAddDetail() {
      this.$router.push("/add/addDetail");
    },
    reject() {
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.newadd {
  background: url("@/assets/images/index/shenqingBlue.png") no-repeat;
  width: 1200px;
  height: 120px;
  background-size: 100% 100%;
  padding: 38px 34px;
  box-sizing: border-box;
  span {
    padding-right: 42px;
  }
  &:hover {
    cursor: pointer;
  }
}
.myApply {
  & > div:nth-child(2) {
    background: url("@/assets/images/index/shenqingGray.png") no-repeat;
    width: 1200px;
    height: 120px;
    background-size: 100% 100%;
    padding: 0 0px 0 32px;
    box-sizing: border-box;
    .right {
      & > div {
        width: 220px;
        text-align: center;
      }
      .pr {
        height: 100%;
        justify-content: center;
        cursor: pointer;

        &:hover {
          background: #87bdfa;
          span {
            color: #fff;
          }
        }
      }

      & > div:not(:last-child) {
        border-right: #c5c5c5 solid 1px;
      }
    }
  }
}
.notice {
  .list {
    & > li {
      height: 50px;
      line-height: 50px;
      border-bottom: solid 1px #e7e7e7;
    }
  }
}
.seamless-warp {
  height: 300px;
  overflow: hidden;
}
</style>
